import { useI18n } from 'vue-i18n';
import { formatCurrencyWithoutDecimal } from '@/helpers/currencyHelper.ts';
import type { LocaleSchema } from '@/locales/index.ts';
import type { Project } from '@/typings/projects/Project.ts';
import { ListingTypeEnum } from '@/enums/ListingType';

export function useProject() {
  const { t, locale } = useI18n<{ message: LocaleSchema }>({
    useScope: 'global',
  });

  /**
   * Obtient le prix d'affichage formaté pour un projet
   * @param project Le projet pour lequel obtenir le prix
   * @param listingType Le type de location (Rental ou Sale)
   * @returns Le prix formaté avec la devise et l'unité appropriée
   */
  const getStartingPrice = (project: Project, listingType: ListingTypeEnum, showPerMonthText: boolean | undefined = true): string => {
    // Utiliser uniquement lowestUnitPrice, afficher "Non disponible" si pas disponible
    if (project.lowestUnitPrice == null) {
      return t('common.notAvailable');
    }
    
    const floorPrice = formatCurrencyWithoutDecimal(project.lowestUnitPrice, locale);
    if (listingType === ListingTypeEnum.Rental) {
      return showPerMonthText ? `${floorPrice} / ${t('common.month').toLowerCase()}` : floorPrice;
    }
    return floorPrice;
  };

  return {
    getStartingPrice,
  };
}